import { RequestBase, ResponseBasePage } from "src/app/modules/fwcore/models";
import { GlossaryScope } from "src/app/features/prob/models";

/**
 * Request the glossary scopes that hold terms.
 *
 * No filters, deliberately: 39 scopes against 1,474 glossary rows is a small list read
 * whole to populate a picker, so there is nothing to page or sort server side.
 */
export class RequestGlossaryScope extends RequestBase {
}

/**
 * Response carrying the glossary scopes that hold terms.
 */
export class ResponseGlossaryScope extends ResponseBasePage<GlossaryScope> {
}
